import React, { useDeferredValue } from 'react';
import CreateInspectorForm, {
  INITIAL_VALUES
} from 'app/components/Forms/CreateInspector';
import styled from '@emotion/styled';
import { FormInstance, Space, notification } from 'antd';
import Button from 'app/components/Button';
import {
  useCreateInspectorMutation,
  useLazyGetInspectorQuery,
  useUpdateInspectorMutation
} from 'app/features/account-management/api';
import { useNavigate, useParams } from 'react-router';
import get from 'lodash/get';
import PageHeader from 'app/components/PageHeader';
import { Title } from 'app/components/Typography/Title';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const CreatingInspector = () => {
  const mode = React.useRef('creating');

  const navigate = useNavigate();
  const params = useParams();

  const [createInspector, result] = useCreateInspectorMutation();
  const [updateInspector] = useUpdateInspectorMutation();

  const [fetch, fetchResult] = useLazyGetInspectorQuery();
  const [isNotValid, setIsNotValid] = React.useState(true);
  const notValid = useDeferredValue(isNotValid);
  const formInstance = React.useRef<FormInstance<any>>();
  const onBack = () => {
    navigate('/dashboard/account-management');
  };
  const onValuesChange = async () => {
    try {
      await formInstance.current?.validateFields(['email']);
      setIsNotValid(false);
    } catch (error) {
      setIsNotValid(!!(error as any).errorFields.length);
    }
  };

  const onCreateOrUpdate = async (values: Record<string, any>) => {
    try {
      const response: any = await (mode.current === 'creating'
        ? createInspector(values)
        : updateInspector({
            inspectorId: params.inspectorId || '',
            data: values
          }));
      if (response.error) {
        const message = get(response.error.data, 'msg.message');
        notification.error({ message, placement: 'bottomLeft' });
        return;
      }
      notification.success({
        message:
          mode.current === 'creating' ? 'User Created!' : 'User Updated!',
        placement: 'bottomLeft'
      });
      navigate('/dashboard/account-management');
    } catch (error) {
      console.log('Creating-Inspector-Error', error);
    }
  };
  React.useEffect(() => {
    const { inspectorId } = params;
    if (inspectorId) {
      mode.current = 'editing';
      fetch(inspectorId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(() => {
    if (formInstance.current) {
      const values: any = get(fetchResult.data, 'data', INITIAL_VALUES);
      formInstance.current.setFieldsValue(values);
      setTimeout(() => {
        onValuesChange();
      });
    }
  }, [fetchResult.data, formInstance]);
  return (
    <div>
      <PageHeader onBack={onBack} title="Back">
        <>
          <Title level={3}>
            {mode.current === 'creating' ? 'Create New User' : 'Edit User'}
          </Title>
          {
            //Create empty block.
          }
          <div></div>
        </>
      </PageHeader>
      <Container>
        <Space direction="vertical" size={20}>
          {!fetchResult.isLoading && (
            <CreateInspectorForm
              initialValues={{
                ...INITIAL_VALUES,
                ...get(fetchResult.data, 'data', {})
              }}
              title={mode.current === 'creating' ? 'Create New User' : 'User'}
              onFinish={onCreateOrUpdate}
              onValuesChange={onValuesChange}
              ref={formInstance}
            ></CreateInspectorForm>
          )}

          <Button
            loading={result.isLoading}
            onClick={() => {
              formInstance.current?.submit();
            }}
            type="primary"
            disabled={notValid}
          >
            Save
          </Button>
        </Space>
      </Container>
    </div>
  );
};

export default CreatingInspector;
